<template>
  <smd-chat-status v-bind="chatStatusBindValues"
                   class="chat-item-order"
                   :class="{'smd-panel': !$isMobile, archived}"
                   @click.native="onItemClick">
  </smd-chat-status>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {
    messageDateFormatter,
  } from '@/utils/dates';
  import {
    ORDER_CHAT_ROUTE,
    ORDER_CHAT_ROUTE_PARAM,
  } from '@/router/routes';
  import GetElementStringMixin from '@/mixins/get-element-string';
  import OrderMessageParserMixin from '@/mixins/messages/order-message-parser-mixin';
  import Ico001 from '@/assets/images/ico001.svg';
  import {
    GETTER_UNREAD_MESSAGES,
    GETTER_PAST_MEDICINE_ORDERS,
  } from '@/store/types';

  export default {
    name: 'chat-item-order',
    mixins: [
      GetElementStringMixin,
      OrderMessageParserMixin,
    ],
    props: {
      order: {type: Object, required: true},
    },
    computed: {
      ...mapGetters({
        unreadCountsList: GETTER_UNREAD_MESSAGES,
        archivedOrders: GETTER_PAST_MEDICINE_ORDERS,
      }),
      name() {
        return this.getElementString('txt116', {strings: [this.order.orderrefno]});
      },
      message() {
        return this.order.lastOrderMessage
          ? this.getParsedOrderMessage(
            this.order.lastOrderMessage.msg,
            (this.order.lastOrderMessage.msgtype || this.order.lastOrderMessage.type),
          )
          : this.getElementString('txt198');
      },
      dateString() {
        return messageDateFormatter(this.order.lastMessageDate);
      },
      image() {
        return Ico001;
      },
      archived() {
        return !!this.archivedOrders.find(({orderid}) => orderid === this.order.orderid);
      },
      chatStatusBindValues() {
        const bindValues = {
          name: this.name,
          message: this.message,
          dateString: this.dateString,
          image: this.image,
        };

        if (this.unreadCountsList[this.order.orderid]) {
          bindValues.unread = !!this.unreadCountsList[this.order.orderid];
          bindValues.notifs = this.unreadCountsList[this.order.orderid];
        }

        return bindValues;
      },
    },
    methods: {
      onItemClick() {
        this.$router.push({
          name: ORDER_CHAT_ROUTE,
          params: {
            [ORDER_CHAT_ROUTE_PARAM]: this.order.orderid,
          },
        });
      },
    },
  }
</script>

<style lang="scss">
  .chat-item-order {
    &.archived {
      opacity: 0.5;
    }
  }
</style>
